export enum ListingSource {
  INTERNET = 'internet',
  BOOKLET = 'booklet',
  OTHER = 'other'
}
